import { render } from "./AdminDeviceLogsList.vue?vue&type=template&id=77c15860"
import script from "./AdminDeviceLogsList.vue?vue&type=script&lang=js"
export * from "./AdminDeviceLogsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__